import UserOverview from './UserOverview'

const ROUTES = [
    UserOverview
]

export default ROUTES
